/*
 * Native Collective purchase section.
 *
 * Add-to-cart itself is handled by the theme's <product-form> element, which posts to
 * /cart/add and renders the cart drawer. This file only keeps the visible state — price,
 * stock line, submit button — in step with the selected variant. No analytics events are
 * emitted here: native checkout reports add_to_cart / begin_checkout / purchase itself.
 */
(function () {
  'use strict';

  function apply(section, input) {
    if (!input) return;

    const available = input.dataset.variantAvailable === 'true';
    const priceAmount = section.querySelector('[data-beer-price] .beer-purchase__price-amount');
    const priceNote = section.querySelector('[data-beer-price] .beer-purchase__price-note');
    const status = section.querySelector('[data-beer-stock-status]');
    const statusText = section.querySelector('[data-beer-stock-text]');
    const submit = section.querySelector('[data-beer-submit]');
    const submitText = section.querySelector('[data-beer-submit-text]');

    if (priceAmount) priceAmount.textContent = input.dataset.variantPrice || priceAmount.textContent;
    if (priceNote) priceNote.textContent = input.dataset.variantTitle || priceNote.textContent;

    if (status) {
      status.classList.toggle('beer-purchase__stock-status--in-stock', available);
      status.classList.toggle('beer-purchase__stock-status--out-of-stock', !available);
    }
    if (statusText) statusText.textContent = available ? 'In stock' : 'Sold out';

    if (submit) {
      submit.disabled = !available;
      if (submitText) submitText.textContent = available ? 'Add to bag' : 'Sold out';
    }

    section.querySelectorAll('.beer-purchase__variant').forEach((label) => {
      const radio = label.querySelector('input[name="id"]');
      label.classList.toggle('beer-purchase__variant--selected', radio === input);
    });

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function init(section) {
    if (section.dataset.beerPurchaseReady === 'true') return;
    section.dataset.beerPurchaseReady = 'true';

    const inputs = section.querySelectorAll('[data-beer-variants] input[name="id"]');
    if (!inputs.length) return;

    inputs.forEach((input) => {
      input.addEventListener('change', () => apply(section, input));
    });

    apply(section, section.querySelector('[data-beer-variants] input[name="id"]:checked'));
  }

  function start() {
    document.querySelectorAll('[data-beer-purchase]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-beer-purchase]').forEach(init);
  });
})();
